//tanto como el titlo de los modelos y la lista quedarán ocultas por defecto
$('#list-models li').hide(); 
$('#title-on-model').hide(); 

/*recorremos el atributo colo-id de la lista colores de productos*/
$("#list-colors-availible li").each(function() {
  let colorIDProducts = $(this).attr('color-id').split('|')[1];
  
  //recorremos la lista de modelos
  $("#list-models li").each(function() {
  let colorIDModels = $(this).attr('color-id').split('|')[1];
    if(colorIDProducts == colorIDModels) {
    	$('#title-on-model').show();
        $(this).show();
    }
  

  });
});